import { DRIZZLE_DEFAULTS } from '@cli-constants/schema.js'

export function resolveVarcharLength(field: { length?: number }): number {
  return field.length ?? DRIZZLE_DEFAULTS.VARCHAR_LENGTH
}
